import { TmapApp } from '@tmap-web-lib/tmap-app-interface';
import { TmapLog } from '@tmap-web-lib/tmap-log-client';
import { isLocalEnv } from '@tmap-web-lib/utils';
import { useCallback } from 'react';

export function useTmapLog() {
  /**
   * 이벤트 로그 전송
   *
   * @param pageId - 페이지 ID
   * @param actionId - 액션 ID
   * @param custom - 추가로 포함할 커스텀 필드 객체
   * @param timeout - 타임아웃 시간(단위: ms, 기본값: 3000) / 지정된 시간 안에 로그 전송이 완료 안 되면 강제 resolve
   *
   * @returns 로그 전송 성공 여부를 나타내는 `Promise<boolean>` 객체
   */
  const eventLog = useCallback(
    (pageId: string, actionId?: string, custom?: Record<string, any>, timeout: number = 3000) => {
      const log = TmapLog('event').setPageId(pageId);
      if (actionId) log.setActionId(actionId);
      const mergedCustom = { ...custom };
      console.log('custom', mergedCustom, custom);
      Object.entries(mergedCustom).forEach(([key, value]) => {
        log.setCustom(key, value as any);
      });

      console.log(
        '[ eventLog ] ',
        'isInApp:' + TmapApp.env.isInApp,
        '| pageId:',
        pageId,
        actionId ? `| actionId: ${actionId}` : '',
        custom && Object.keys(custom).length > 0 ? `| custom: ${JSON.stringify(custom)}` : ''
      );

      if (TmapApp.env.isInApp || isLocalEnv()) {
        return Promise.race([
          log
            .send()
            .then((v) => {
              console.log('[ eventLog Success ]', v);
            })
            .catch((e) => {
              console.error('[ eventLog Error ] ', e);
            }),
          new Promise<void>((resolve) => setTimeout(resolve, timeout)),
        ]);
      }
    },
    []
  );

  /**
   * 노출 로그 전송
   *
   * @param pageId - 페이지 ID
   * @param actionId - 액션 ID
   * @param custom - 추가로 포함할 커스텀 필드 객체
   * @param timeout - 타임아웃 시간(단위: ms, 기본값: 3000) / 지정된 시간 안에 로그 전송이 완료 안 되면 강제 resolve
   *
   * @returns 로그 전송 성공 여부를 나타내는 `Promise<boolean>` 객체
   */
  const exposeLog = useCallback(
    (pageId: string, actionId?: string, custom?: Record<string, any>, timeout = 3000) => {
      const log = TmapLog('expose').setPageId(pageId);
      if (actionId) log.setActionId(actionId);

      if (custom) {
        Object.entries(custom).forEach(([key, value]) => {
          log.setCustom(key, value as any);
        });
      }

      console.log(
        '[ exposeLog ] ',
        'isInApp:' + TmapApp.env.isInApp,
        '| pageId:',
        pageId,
        actionId ? `| actionId: ${actionId}` : '',
        custom && Object.keys(custom).length > 0 ? `| custom: ${JSON.stringify(custom)}` : ''
      );

      if (TmapApp.env.isInApp || isLocalEnv()) {
        return Promise.race([
          log
            .send()
            .then((v) => {
              console.log('[ exposeLog Success ]', v);
            })
            .catch((e) => {
              console.error('[ exposeLog Error ] ', e);
            }),
          new Promise<void>((resolve) => setTimeout(resolve, timeout)),
        ]);
      }
    },
    []
  );

  return { eventLog, exposeLog };
}
